module.exports = __webpack_public_path__ + "static/media/poster_notext.f04b5688.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/poster_notext.png
// module id = 381
// module chunks = 4